import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    templateUrl: './notFound.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NotFoundComponent  {

  constructor() {
  }

}
